<template>
  <div>
    <div class="columns is-multiline is-vcentered is-variable is-1">
      <div class="column is-12-desktop is-6-widescreen">
        <h3 class="title is-size-4 is-size-5-mobile">{{ $t('payment.giftcard.header') }}</h3>
        <p class="mb-4 is-text-wrap-pretty">{{ $t('payment.giftcard.payment_info') }}</p>
      </div>
      <div class="column is-12-desktop is-6-widescreen">
        <b-button type="is-dark" @click="showCodeModal" class="is-fullwidth">{{ $t('payment.giftcard.redeem_card') }}</b-button>
        <!-- <div v-if="showCardEntry">
          <b-field label="Karten-Code">
            <b-input class="full-width" placeholder="" v-model="tan"> </b-input>
            <p class="control">
              <b-button type="is-primary" label="Einlösen" @click="checkGiftCard" />
            </p>
          </b-field>
        </div> -->
      </div>
    </div>

    <b-modal v-model="isCodeModalActive" :width="400" scroll="keep">
      <div class="modal-card px-3" style="width:auto">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t('payment.giftcard.enter_card_code') }}</p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$t('payment.giftcard.your_card_code')" :type="codeFieldType" :message="codeFieldMessage">
            <b-input class="full-width" placeholder="" v-model="tan"> </b-input>
            <!-- <p class="control">
              <b-button type="is-primary" label="Einlösen" @click="checkGiftCard" />
            </p> -->
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button type="is-text" :label="$t('general.close')" @click="closeCodeModal" />
          <b-button expanded :label="$t('general.redeem')" type="is-primary" @click="checkGiftCard" />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'GiftCard',
  components: {},
  data() {
    return {
      showCardEntry: false,
      tan: '',
      isCodeModalActive: false,
      codeFieldType: '',
      codeFieldMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      subtotal: 'cartSubTotal',
      total: 'cartTotal',
      payment: 'cartPaymentType',
    }),
  },
  mounted() {
    if (this.payment.paymentTypeId === 20) {
      this.$emit('next-step')
    }
  },
  watch: {
    total(newVal, oldVal) {
      //todo also watch if its above 0 again
      //and then redirect back to payment selection IF choose payment method is giftcard
      if (newVal === 0 && this.subtotal > 0) {
        this.$emit('next-step')
      } else if (oldVal === 0 && newVal > 0 && this.subtotal > 0) {
        this.$emit('start-over')
      }
    },
  },
  methods: {
    ...mapActions(['addGiftCard']),
    toggleGiftCardEntry() {
      this.showCardEntry = !this.showCardEntry
      if (this.total == 0 && this.subtotal > 0) {
        this.$emit('next-step')
      }
    },
    showCodeModal() {
      this.isCodeModalActive = true
    },
    closeCodeModal() {
      this.isCodeModalActive = false

      //clear codefield
      this.codeFieldType = ''
      this.codeFieldMessage = ''
      this.tan = ''
    },
    async checkGiftCard() {
      const before = this.total
      await this.addGiftCard(this.tan)
      if (before == this.total) {
        // this.$buefy.toast.open({
        //   duration: 5000,
        //   message: this.$t('errors.gift-card-expired'),
        //   position: 'is-bottom',
        //   type: 'is-info',
        // })

        this.codeFieldType = 'is-danger'

        if (this.tan.trim() === '') {
          this.codeFieldMessage = this.$t('errors.gift-card-enter-valid')
        } else {
          this.codeFieldMessage = this.$t('errors.gift-card-expired')
        }
      } else {
        this.closeCodeModal()
        this.$buefy.toast.open({
          duration: 5000,
          message: this.$t('errors.gift-card-successfully-redeemed'),
          position: 'is-bottom',
          type: 'is-info',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
